import { toTypedSchema } from '@vee-validate/yup';
import { object, string } from 'yup';
import type { TypedSchema } from 'vee-validate';

export const validationSchema: TypedSchema = toTypedSchema(object({
    code: string().required(),
}));
